/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CouponIdEnrollmentLinks200,
  GetApiV1CouponIdEnrollmentLinks401,
  GetApiV1CouponIdEnrollmentLinks404,
  GetApiV1CouponIdEnrollmentLinks500,
  GetApiV1CouponIdEnrollmentLinksPathParams,
  GetApiV1CouponIdEnrollmentLinksQueryResponse,
} from "../../types/couponLinksDeMatrculaController/GetApiV1CouponIdEnrollmentLinks.ts";
import { couponEnrollmentLinksViewModelSchema } from "../couponEnrollmentLinksViewModelSchema.ts";

export const getApiV1CouponIdEnrollmentLinksPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1CouponIdEnrollmentLinksPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CouponIdEnrollmentLinks200Schema = z.lazy(
  () => couponEnrollmentLinksViewModelSchema,
) as unknown as ToZod<GetApiV1CouponIdEnrollmentLinks200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CouponIdEnrollmentLinks401Schema =
  z.any() as unknown as ToZod<GetApiV1CouponIdEnrollmentLinks401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CouponIdEnrollmentLinks404Schema =
  z.any() as unknown as ToZod<GetApiV1CouponIdEnrollmentLinks404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CouponIdEnrollmentLinks500Schema =
  z.any() as unknown as ToZod<GetApiV1CouponIdEnrollmentLinks500>;

export const getApiV1CouponIdEnrollmentLinksQueryResponseSchema = z.lazy(
  () => getApiV1CouponIdEnrollmentLinks200Schema,
) as unknown as ToZod<GetApiV1CouponIdEnrollmentLinksQueryResponse>;
